"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FormStateErrorBanner = void 0;
const design_system_1 = require("@servicetitan/design-system");
const react_1 = __importDefault(require("react"));
const mobx_react_1 = require("mobx-react");
const __1 = require("..");
exports.FormStateErrorBanner = mobx_react_1.observer(({ form, className, errorTitle = 'Form Incomplete', successTitle = 'Form Complete', }) => {
    const errors = [];
    __1.traverseFormState(true, form, (_0, formState) => {
        if (formState.formError) {
            errors.push(formState.formError);
        }
    });
    if (form.formError) {
        errors.push(form.formError);
    }
    const status = errors.length === 0 ? 'success' : 'critical';
    const title = errors.length === 0 ? successTitle : errorTitle;
    return (react_1.default.createElement(design_system_1.Banner, { className: className, status: status, icon: true, title: title },
        react_1.default.createElement("ul", null, errors.map((e, index) => (
        // eslint-disable-next-line react/no-array-index-key
        react_1.default.createElement("li", { key: index }, e))))));
});
//# sourceMappingURL=form-state-error-banner.js.map